<template>
  <div>
    <div class="fix-wrapper">
      <breadcrumb :crumbs="[$t('menu.settings'), $t('text.list')]">
      </breadcrumb>
      <div class="container">
        <el-form
          ref="tenantForm"
          :model="tenant"
          label-width="100px"
          size="small"
        >
          <div class="pd20">
            <fieldset class="mgb15">
              <legend>
                {{ $t("text.baseInfo") }}
                <span class="float-right orange font10"
                  >{{ $t("tenant.scoreRate") }}：{{
                    $t("tenant.scoreRatePrompt")
                  }}</span
                >
              </legend>
              <el-row>
                <el-col :span="8">
                  <el-form-item
                    :label="$t('courier.contact')"
                    :prop="'yshopConcatName'"
                    :rules="[
                      {
                        required: true,
                        message: $t('rules.required', [$t('courier.contact')]),
                        trigger: 'blur',
                      },
                    ]"
                  >
                    <el-input
                      size="small"
                      v-model.trim="tenant.yshopConcatName"
                    ></el-input>
                  </el-form-item>
                </el-col>
                <el-col :span="8">
                  <el-form-item
                    :label="$t('courier.phone')"
                    :prop="'yshopConcatPhone'"
                    :rules="[
                      {
                        required: true,
                        message: $t('rules.required', [$t('courier.phone')]),
                        trigger: 'blur',
                      },
                    ]"
                  >
                    <el-input
                      size="small"
                      v-model.trim="tenant.yshopConcatPhone"
                    ></el-input>
                  </el-form-item>
                </el-col>
                <el-col :span="8">
                  <el-form-item :label="$t('tenant.country')">
                    <el-select v-model="tenant.country" filterable>
                      <el-option
                        v-for="country in countries"
                        :key="country"
                        :label="$t('countries.' + country)"
                        :value="country"
                      ></el-option>
                    </el-select>
                  </el-form-item>
                </el-col>
              </el-row>
              <el-row>
                <el-col :span="8">
                  <el-form-item
                    :label="$t('tenant.province')"
                    :prop="'province'"
                  >
                    <el-input v-model="tenant.province"></el-input>
                  </el-form-item>
                </el-col>
                <el-col :span="8">
                  <el-form-item :label="$t('tenant.city')" :prop="'city'">
                    <el-input v-model="tenant.city"></el-input>
                  </el-form-item>
                </el-col>
                <el-col :span="8">
                  <el-form-item :label="$t('tenant.address')" :prop="'address'">
                    <el-input v-model="tenant.address"></el-input>
                  </el-form-item>
                </el-col>
              </el-row>
              <el-row>
                <el-col :span="8">
                  <el-form-item
                    :label="$t('text.owner')"
                    :prop="'yshopOwnerId'"
                    :rules="[
                      {
                        required: true,
                        message: $t('rules.required', [$t('text.owner')]),
                        trigger: 'blur',
                      },
                    ]"
                  >
                    <el-select
                      size="small"
                      v-model="tenant.yshopOwnerId"
                      filterable
                    >
                      <el-option
                        v-for="user in users"
                        :key="user.id"
                        :label="user.name"
                        :value="user.id"
                      ></el-option>
                    </el-select>
                  </el-form-item>
                </el-col>
                <el-col :span="8">
                  <el-form-item
                    :label="$t('menu.shops')"
                    :prop="'yshopShopId'"
                    :rules="[
                      {
                        required: true,
                        message: $t('rules.required', [$t('menu.shops')]),
                        trigger: 'blur',
                      },
                    ]"
                  >
                    <el-select
                      size="small"
                      v-model="tenant.yshopShopId"
                      filterable
                    >
                      <el-option
                        v-for="shop in shops"
                        :key="shop.id"
                        :label="shop.name"
                        :value="shop.id"
                      ></el-option>
                    </el-select>
                  </el-form-item>
                </el-col>
                <el-col :span="8">
                  <el-form-item
                    :label="$t('tenant.scoreRate')"
                    :prop="'scoreRate'"
                  >
                    <el-input
                      v-model="tenant.scoreRate"
                      :placeholder="$t('tenant.scoreRatePrompt')"
                    ></el-input>
                  </el-form-item>
                </el-col>
              </el-row>
            </fieldset>
            <el-row :gutter="20">
              <el-col :span="10">
                <fieldset class="mgb15">
                  <legend>
                    赢小店轮播图<span class="orange font10">建议宽高比2:1</span>
                  </legend>
                  <dropzone v-model="tenant.slideImages" multiple />
                </fieldset>
              </el-col>
              <el-col :span="8">
                <fieldset class="mgb15">
                  <legend>店铺介绍</legend>
                  <el-input
                    v-model="tenant.introduction"
                    type="textarea"
                    :rows="4"
                  />
                </fieldset>
              </el-col>
              <el-col :span="6">
                <fieldset class="mgb15">
                  <legend>
                    介绍图片<span class="font10 orange"
                      >*建议宽750px,高500px</span
                    >
                  </legend>
                  <upload-single-picture v-model="tenant.introductionImage" />
                </fieldset>
              </el-col>
            </el-row>
          </div>
          <div class="form-footer">
            <el-button
              type="primary"
              size="medium"
              plain
              :loading="saveDoing"
              @click="saveSubmit"
              >{{ $t("text.submit") }}</el-button
            >
          </div>
        </el-form>
      </div>
    </div>
  </div>
</template>
<script>
import axios from "axios";
import { page } from "@/utils/mixins.js";
import Tenant from "@/api/tenant.js";
import User from "@/api/user.js";
import Shop from "@/api/shop.js";
import Dropzone from "@/components/Dropzone";
import UploadSinglePicture from "@/components/UploadSinglePicture";
import { countries } from "@/utils/enums.js";

export default {
  mixins: [page],
  components: { Dropzone, UploadSinglePicture },
  data() {
    return {
      tenant: {
        country: null,
        province: null,
        city: null,
        introduction: null,
        address: null,
        slideImages: null,
        introductionImage: null,
        yshopConcatName: null,
        yshopConcatPhone: null,
        yshopOwnerId: null,
        yshopShopId: null,
      },
      countries: countries,
      users: [],
      shops: [],
      saveDoing: false,
    };
  },
  created() {
    const self = this;
    self.loadData();
    axios.all([Shop.findByTenantId(), User.findByTenantId()]).then(
      axios.spread(function (shops, users) {
        if (shops.status === 200) {
          self.shops = shops.data;
        } else {
          self.sysError();
        }
        if (users.status === 200) {
          self.users = users.data.filter(
            (u) => u.voidAt == null && u.authorize === true
          );
        } else {
          self.sysError();
        }
      })
    );
  },
  methods: {
    //
    saveSubmit() {
      const self = this;
      self.saveDoing = true;
      Tenant.updateYshopInfo(self.Permit.currentTenant().id, self.tenant).then(
        function (res) {
          self.saveDoing = false;
          if (res.status == 200) {
            self.$message({
              message: self.$t("prompt.saveSuccess"),
              type: "success",
            });
            self.loadData();
          } else {
            self.sysError();
          }
        }
      );
    },

    loadData() {
      const self = this;
      self.loadingStart();
      Tenant.findById(self.Permit.currentTenant().id).then(function (res) {
        if (res.data.code === 200) {
          self.tenant = res.data.entity;
        } else {
          self.sysError();
        }
        self.loadingEnd();
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.clear-data-prompt {
  color: #ff9b6a;
}
.clear-data-prompt li {
  line-height: 30px;
}
</style>